/* bymayfield — sticky add-to-cart bar behaviour.
   Pairs with snippets/mb-sticky-atc.liquid. Reveals the bar once the
   main Add-to-cart button scrolls off-screen, keeps the variant
   image, price, selectors and button in sync with the main product
   form, and submits through Dawn's native <product-form>. */
if (!customElements.get('mb-sticky-atc-bar')) {
  customElements.define(
    'mb-sticky-atc-bar',
    class MbStickyAtcBar extends HTMLElement {
      connectedCallback() {
        // Re-home to <body> so position:fixed stays viewport-relative
        // (Dawn section reveal-transforms otherwise trap a fixed child).
        if (this.parentElement && this.parentElement !== document.body) {
          document.body.appendChild(this);
          return; // connectedCallback fires again after the re-attach
        }
        try {
          this.setup();
        } catch (e) {
          /* never let the sticky bar break the product page */
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.unsubscribe) this.unsubscribe();
      }

      setup() {
        this.variantInput = this.querySelector('input[name="id"]');
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.imageEl = this.querySelector('[data-sticky-image]');
        this.submitBtn = this.querySelector('button[type="submit"]');
        this.submitText = this.submitBtn && this.submitBtn.querySelector('span');
        this.selects = this.querySelectorAll('[data-sticky-option-index]');

        this.variants = [];
        this.prices = {};
        try { this.variants = JSON.parse(this.dataset.variants || '[]'); } catch (e) {}
        try { this.prices = JSON.parse(this.dataset.prices || '{}'); } catch (e) {}

        // Main product section + its real Add-to-cart button
        this.productSection =
          document.querySelector('[id^="MainProduct"]') ||
          document.querySelector('.product');
        var anchor =
          (this.productSection &&
            (this.productSection.querySelector('.product-form__submit') ||
              this.productSection.querySelector('[name="add"]'))) ||
          this.productSection;

        // Reveal the bar once the main button has scrolled above the viewport
        if (anchor && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                var scrolledPast =
                  !entry.isIntersecting && entry.boundingClientRect.top < 0;
                this.classList.toggle('is-visible', scrolledPast);
                // Reserve space on mobile so the fixed bar never hides the
                // footer's bottom (payment icons / legal links) at full scroll.
                if (window.matchMedia('(max-width: 749px)').matches) {
                  document.body.style.paddingBottom = scrolledPast
                    ? this.offsetHeight + 'px'
                    : '';
                } else {
                  document.body.style.paddingBottom = '';
                }
              });
            },
            { threshold: 0 }
          );
          this.observer.observe(anchor);
        }

        // Main variant picker -> sticky bar
        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(
            PUB_SUB_EVENTS.variantChange,
            this.onMainVariantChange.bind(this)
          );
        }

        // Sticky bar dropdowns -> form + main picker
        this.selects.forEach((select) => {
          select.addEventListener('change', () => this.onStickySelectChange());
        });
      }

      // Ask the Shopify CDN for a small thumbnail of the variant image
      sizedImage(src) {
        if (!src) return src;
        return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=200';
      }

      applyVariant(variant) {
        if (!variant) return;

        if (this.variantInput && variant.id != null) {
          this.variantInput.value = variant.id;
        }

        var price = this.prices[variant.id];
        if (this.priceEl && price) {
          this.priceEl.innerHTML = price.c
            ? '<s>' + price.c + '</s>' + price.p
            : price.p;
        }

        if (this.imageEl && variant.featured_image && variant.featured_image.src) {
          this.imageEl.src = this.sizedImage(variant.featured_image.src);
        }

        this.updateButton(variant.available);
      }

      onMainVariantChange(event) {
        var variant = event && event.data && event.data.variant;
        if (!variant) {
          this.updateButton(false);
          return;
        }
        this.applyVariant(variant);
        // Mirror the dropdowns to the picked variant
        if (variant.options) {
          this.selects.forEach((select, i) => {
            if (variant.options[i] != null) select.value = variant.options[i];
          });
        }
      }

      onStickySelectChange() {
        var picked = Array.prototype.map.call(this.selects, function (s) {
          return s.value;
        });
        var variant = this.variants.find(function (v) {
          return v.options && v.options.every(function (opt, i) {
            return opt === picked[i];
          });
        });
        if (variant) {
          this.applyVariant(variant);
          this.syncToMainPicker(picked);
        } else {
          this.updateButton(false);
        }
      }

      // Push the sticky selection into Dawn's real picker so the
      // gallery, price and main form all follow along.
      syncToMainPicker(picked) {
        if (!this.productSection) return;
        var main =
          this.productSection.querySelector('variant-selects') ||
          this.productSection.querySelector('variant-radios');
        if (!main) return;

        var fieldsets = main.querySelectorAll('fieldset');
        if (fieldsets.length) {
          fieldsets.forEach((fieldset, i) => {
            if (picked[i] == null) return;
            var safe = window.CSS && CSS.escape ? CSS.escape(picked[i]) : picked[i];
            var radio = fieldset.querySelector('input[value="' + safe + '"]');
            if (radio && !radio.checked) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
          return;
        }

        main.querySelectorAll('select').forEach((select, i) => {
          if (picked[i] != null && select.value !== picked[i]) {
            select.value = picked[i];
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      updateButton(available) {
        if (!this.submitBtn) return;
        if (available) {
          this.submitBtn.removeAttribute('disabled');
          if (this.submitText) {
            this.submitText.textContent =
              (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
          }
        } else {
          this.submitBtn.setAttribute('disabled', 'disabled');
          if (this.submitText) {
            this.submitText.textContent =
              (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
          }
        }
      }
    }
  );
}
